import { FC, Fragment, HTMLAttributes } from 'react';

import { useRecoilState, useRecoilValue } from 'recoil';

import { Dialog, Transition } from '@headlessui/react';
import { useModalHook } from '@shared/hooks/useModalHook';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { customThemeAtom } from '@shared/state/atom/theme.atom';
import { CustomCallback } from '@shared/types';

interface Props extends HTMLAttributes<HTMLDivElement> {
  openId: string;
  onClose?: CustomCallback<any, void>;
}

/**
 * @param openId
 * @param onClose
 * @returns 사이드팝업, 메뉴바용으로 주로사용
 */
export const SidePopup: FC<Props> = function SidePopup({
  openId,
  children,
  onClose,
}: Props) {
  const [open, setOpen] = useRecoilState(simpleOpenAtomFamily(openId));
  const customTheme = useRecoilValue(customThemeAtom);

  useModalHook(openId);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className={`${customTheme} fixed right-0 top-0 z-30 overflow-y-auto`}
        onClose={(e) => {
          if (onClose) {
            onClose(e);
          } else {
            setOpen(false);
          }
          history.back();
        }}
      >
        <div>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-x-4"
            enterTo="opacity-100 translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-4"
          >
            <div className={`inline-block transform shadow-xl transition-all`}>
              {children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
